/**
 * Gradient background classes for assistant avatar fallbacks.
 * Used consistently across AssistantSelector and AssistantForm components.
 */
export const GRADIENT_BACKGROUNDS = [
  "bg-gradient-to-br from-pink-500 to-orange-400", // Pink to orange
  "bg-gradient-to-br from-blue-500 to-cyan-400", // Blue to cyan
  "bg-gradient-to-br from-purple-600 to-indigo-500", // Purple to indigo
  "bg-gradient-to-br from-green-500 to-emerald-400", // Green to emerald
  "bg-gradient-to-br from-yellow-400 to-amber-500", // Yellow to amber
  "bg-gradient-to-br from-red-500 to-rose-400", // Red to rose
  "bg-gradient-to-br from-indigo-600 to-blue-400", // Indigo to blue
  "bg-gradient-to-br from-cyan-500 to-teal-400", // Cyan to teal
  "bg-gradient-to-br from-violet-600 to-purple-400", // Violet to purple
  "bg-gradient-to-br from-amber-500 to-yellow-300", // Amber to yellow
];

/**
 * Determines a gradient background class based on assistant id or name.
 * Uses a consistent hashing algorithm to always return the same gradient
 * for the same assistant.
 *
 * @param {Object} assistant - The assistant object
 * @param {string} [assistant.id] - Assistant ID
 * @param {string} [assistant.name] - Assistant name
 * @returns {string} A Tailwind gradient class
 */
export const getGradientBackground = (assistant) => {
  if (!assistant) return GRADIENT_BACKGROUNDS[0];

  // Use assistant ID if available, otherwise use name
  const idString = assistant.id || assistant.name || "default";

  // Sum the char codes to create a number
  const charSum = idString
    .split("")
    .reduce((sum, char) => sum + char.charCodeAt(0), 0);

  // Use modulo to get an index within our array bounds
  const index = charSum % GRADIENT_BACKGROUNDS.length;

  return GRADIENT_BACKGROUNDS[index];
};
